import { CategoryTag } from 'app/components/common/categories/category-tag';
import { DropdownValue, FlexRow } from '@make-software/cspr-design';
import Select, { components } from 'react-select';
import React from 'react';
import { CategoriesDropdownList } from 'app/components/common/categories/category-dropdown';
import { DropdownStyles } from 'app/components/common/common-styles';

export interface AppsCategoriesSelectPops {
  categories: DropdownValue[];
  handleInputChange: (e: any) => void;
}

export const AppsCategoriesSelect = ({
  categories,
  handleInputChange
}: AppsCategoriesSelectPops) => {
  const CustomMultiValue = (props: any) => {
    return <CategoryTag name={props.data.label} />;
  };

  const CustomOption = (props: any) => {
    const { data, isSelected, innerRef, innerProps } = props;

    return (
      <FlexRow
        gap={8}
        ref={innerRef}
        {...innerProps}
        align={'center'}
        style={{ paddingTop: '4px' }}
      >
        <CategoryTag name={data.label} />
        {isSelected && <components.MultiValueRemove {...props}>×</components.MultiValueRemove>}
      </FlexRow>
    );
  };

  return (
    <Select
      options={CategoriesDropdownList}
      value={categories}
      isMulti={true}
      hideSelectedOptions={false}
      closeMenuOnSelect={false}
      components={{
        MultiValue: CustomMultiValue,
        Option: CustomOption
      }}
      onChange={handleInputChange}
      styles={DropdownStyles()}
    />
  );
};
